import React, { useEffect, useRef } from 'react'
import './styles/App.css'
import './styles/Responsive.css' // Import responsive styles

// Import your components
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import Services from './components/Services'
import Testimonials from './components/Testimonials'
import PricingPlans from './components/PricingPlans'
import JoinSection from './components/JoinSection'
import FAQ from './components/FAQ'
import Contact from './components/Contact'
import Footer from './components/Footer'


function ScrollSection({ children }) {
  const ref = useRef(null)

  useEffect(() => {
    const el = ref.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('visible')
          observer.unobserve(el)
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div ref={ref} className="scroll-section">
      {children}
    </div>
  )
}

function App() {
  return (
      <div className="app-container">
        <Header />
        <HeroSection />
        <ScrollSection><Services /></ScrollSection>
        <ScrollSection><Testimonials /></ScrollSection>
        <ScrollSection><PricingPlans /></ScrollSection>
        {/* <ScrollSection><JoinSection /></ScrollSection> */}
        <ScrollSection><FAQ /></ScrollSection>
        <ScrollSection><Contact /></ScrollSection>
        <ScrollSection><Footer /></ScrollSection>
      </div>
  )
}

export default App
